import React, { useState, useContext } from "react"
import { useHistory, Link  } from "react-router-dom"
import { AuthContext } from '../../contexts/AuthContext';
import axios from "axios";
import { apiRoutes } from '../../AppSettings';
import { SignalRContext } from '../../contexts/SignalRContext';
import Spinner from "../shared/Spinner";

const Login = () => {
    const history = useHistory();
    const { updateUserState } = useContext(AuthContext);
    const { startConnection, join } = useContext(SignalRContext);
    const [loginData, setLoginData] = useState({ Email: '', Password: '' });
    const [errorMessage, setErrorMessage] = useState('');
    const [showSpinner, setShowSpinner] = useState(false);

    const handleSubmit = e => {
        e.preventDefault();
        setShowSpinner(true);
        const options = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
          };
        axios.post(apiRoutes.login, JSON.stringify(loginData), options)
            .then((response) => {
                if(response.status === 200)
                {
                    const data = response.data;

                    if(data.loggedInUser == undefined || data.loggedInUser == null || data.errorMessages)
                    {
                        setShowSpinner(false);
                        setErrorMessage('Invalid credentials, please check and try again.')
                    }
                    else
                    {
                        updateUserState(data.token, data.userDetail, true, data.roles[0], data.loggedInUser);

                        startConnection();
                        setTimeout(() => join(loginData.Email), 2000);

                        if(data.roles[0].toLowerCase() == "admin")
                        {
                            setShowSpinner(false);
                            setErrorMessage('Username or password is incorrect, Please check.')
                        }
                        else
                        {
                            let componentToLoad = '/doctordashboard'
                            switch(data.roles[0].toLowerCase())
                            {
                                case "patient":
                                    componentToLoad = "/patientdashboard"
                                    break;
                                case "doctor":
                                    componentToLoad = '/doctordashboard'
                                    break;
                            }
                            history.push(componentToLoad);
                        }
                    }
                } else {
                    setErrorMessage('Username or password is incorrect, Please check.')
                }
            }, (error) => {

                console.log(error.response);
            })
    };

    return (
        <div className="content">
            <Spinner  show={showSpinner}/>
            <div className="container-fluid">

                <div className="row">
                    <div className="col-md-8 offset-md-2">

                        <div className="account-content">
                            <div className="row align-items-center justify-content-center">
                                <div className="col-md-7 col-lg-6 login-left">
                                    <img src="assets/img/login-banner.png" className="img-fluid" alt="Elixir Login" />
                                </div>
                                <div className="col-md-12 col-lg-6 login-right">
                                    <div className="login-header">
                                        <h3>Login</h3>
                                    </div>
                                    {
                                        errorMessage && 
                                        <div class="alert alert-danger alert-dismissible fade show" role="alert">
										    {errorMessage}
									    </div>
                                    }
                                    <form onSubmit={(e) => handleSubmit(e)}>
                                        <div className="form-group form-focus">
                                            <input
                                                type="email"
                                                className="form-control floating"
                                                required
                                                value={loginData.username}
                                                onChange={e => setLoginData({ ...loginData, Email: e.target.value })} />
                                            <label className="focus-label">Email</label>
                                        </div>
                                        <div className="form-group form-focus">
                                            <input
                                                type="password"
                                                className="form-control floating"
                                                required
                                                value={loginData.password}
                                                onChange={e => setLoginData({ ...loginData, Password: e.target.value })} />
                                            <label className="focus-label">Password</label>
                                        </div>
                                        <div className="text-right">
                                            <a className="forgot-link" href="forgot-password.html">Forgot Password ?</a>
                                        </div>
                                        <button type="submit" className="btn btn-primary btn-block btn-lg login-btn" >Login</button>
                                        <div className="login-or">
                                            <span className="or-line"></span>
                                            <span className="span-or">or</span>
                                        </div>
                                        <div className="row form-row social-login">
                                            <div className="col-6">
                                                <a href="#" className="btn btn-facebook btn-block"><i className="fab fa-facebook-f mr-1"></i> Login</a>
                                            </div>
                                            <div className="col-6">
                                                <a href="#" className="btn btn-google btn-block"><i className="fab fa-google mr-1"></i> Login</a>
                                            </div>
                                        </div>
                                        <div className="text-center dont-have">Don’t have an account? <Link to={'/register'}> Register</Link></div>
                                    </form>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>

        </div>
    );
}

export default Login ;